import { render, staticRenderFns } from "./movement_38menu.vue?vue&type=template&id=7b1e4bd0&"
import script from "./movement_38menu.vue?vue&type=script&lang=js&"
export * from "./movement_38menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports